import Model from '@newspaces/zero-base/Model';
import Organisation from './models/Organisation.js';
import { A as AccessCountries } from './AccessCountries-3e45c6a9.js';

const appendFilter = (filter, key, filterToAdd) => {
  if (filter[key]) {
    if (filter.$and) {
      filter.$and.push({ [key]: filterToAdd });
    } else {
      filter.$and = [{ [key]: filterToAdd }];
    }
  } else {
    filter[key] = filterToAdd;
  }
  return filter;
};

const queryDocument = (filter, _, Runtime) => {
  if (!filter.organisation) {
    return false;
  }
  const organisationUser = Runtime.getOrganisationData(filter.organisation);
  if (!organisationUser) {
    return false;
  }
  const hasScope = (scope) => {
    return Runtime.userHasAllScopes(
      filter.organisation.toString(),
      null,
      scope
    );
  };
  if (!hasScope("accessSite.read")) {
    return false;
  }
  const accessSites = organisationUser.customPermissions?.accessSites;
  let finalFilter = filter;
  if (accessSites?.length) {
    finalFilter = appendFilter(finalFilter, "_id", {
      $in: accessSites
    });
  }
  return { filter: finalFilter, fields: "all" };
};

const canEditOrRemoveDocument = async (filter, Runtime, operation) => {
  const { organisation: organisationId } = filter;
  if (!organisationId) {
    return false;
  }
  const organisationUser = Runtime.getOrganisationData(organisationId);
  if (!organisationUser) {
    return false;
  }
  const hasScope = (scope) => {
    return Runtime.userHasAllScopes(
      organisationId.toString(),
      null,
      scope
    );
  };
  if (!hasScope(`accessSite.${operation}`)) {
    return false;
  }
  const allowedAccessSites = organisationUser.customPermissions?.accessSites;
  if (allowedAccessSites?.length) {
    const accessSites = await Runtime.db.collection("accessSites").find(filter, {
      projection: {
        _id: 1
      }
    }).toArray();
    return accessSites.every((document) => {
      return allowedAccessSites.some((accessSiteId) => `${accessSiteId}` === `${document._id}`);
    });
  }
  return true;
};

const editDocument = async (filter, _, __, context) => {
  return canEditOrRemoveDocument(filter, context, "edit");
};

const removeDocument = async (filter, context) => {
  return canEditOrRemoveDocument(filter, context, "remove");
};

const Permissions = {
  read: [
    {
      who: "owner"
    },
    {
      query: queryDocument
    }
  ],
  edit: [
    {
      who: "owner"
    },
    {
      query: editDocument
    }
  ],
  remove: [
    {
      who: "owner"
    },
    {
      query: removeDocument
    }
  ]
};

class AccessSite extends Model {
  static CollectionName = "accessSites";
  static Permissions = Permissions;
  static Fields = {
    organisation: {
      type: Organisation,
      required: true,
      serialize: "insert"
    },
    name: {
      type: String,
      required: true,
      description: "The name of this site"
    },
    description: {
      type: String,
      description: "Optional description of the site"
    },
    siteId: {
      type: Number,
      serialize: false,
      description: "The unique ID of this site. Automatically generated by the system.",
      unique: "local"
    },
    location: {
      type: String,
      enum: AccessCountries.getAsKeys(),
      required: true,
      serialize: "insert",
      description: "The actual location of the device defining timezone and more"
    },
    credentialMode: {
      type: String,
      enum: ["blueidApp", "customApp", "apiOnly"],
      default: "blueidApp",
      required: true,
      serialize: "insert",
      description: "The credential mode that will define how the credential is sent to the user"
    },
    customActivationUrl: {
      type: String,
      serialize: "insert",
      required: ({ credentialMode }) => credentialMode === "customApp",
      description: "URL used to activate credentials of custom apps"
    },
    ossSoAppId: {
      type: Number,
      serialize: false,
      description: "The unique oss so app id for nfc cards"
    },
    ossSidAppId: {
      type: Number,
      serialize: false,
      description: "The unique oss sid app id for nfc cards"
    }
  };
  constructor(data) {
    super(AccessSite.Fields, data);
  }
  // eslint-disable-next-line class-methods-use-this
  getMergeTagProperties() {
    return {
      name: { key: "name" }
    };
  }
}
Model.declareModel(AccessSite);

export { AccessSite as A, appendFilter as a };
//# sourceMappingURL=AccessSite-5abc043f.js.map
